function pick(items, key) {
	if (!items) {
		return [];
	}
	return items.map((item) => item[key]);
}

export default pick;